// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__51cZc","delete":"styles_delete__xcJiO","update":"styles_update__2yL2-","add":"styles_add__3d68r"};